<template>

	<div class="registrations-container">
		<MenuPartnerIntegrations :current="action" @changeTabMenuSideBar="(tab) => action = tab"/>

		<div class="registrations-main" v-if="action === null">
			
			<div class="dash-headline-two">
				<div class="d-flex align-items-center">
					<h2 class="tx-inverse mg-b-0">
						Crawler de Tracking
					</h2>
				</div>
			</div>

			<hr class="mb-1" />
			
			<PartnerIntegrationsFilter @find-processes-with-data="getProcesses($event, true)" :showIdentification="true"/>

			<hr class="mb-4" />

			<div class="ov-h height-calc">
				<div class="columns md-gap">
					<!-- Col 1 -->
					<div class="span-8 bd height-calc-h ov-h">
						<div class="light-bg p-3 bd-b">
							<div :class="['flex ai-c jc-sb fw-w fgap2']">
							<div>
								<h4 class="mb-0 text-dark text-bold">
								INTEGRAÇÕES RECEBIDAS DOS CRAWLER DE TRACKING
								</h4>
							</div>
							<div>
								<button type="button" class="crm-button gray" @click="refreshProcessOpen">
									<div class="flex ai-c fgap1">
										<refresh-icon color="#fff"/>
										<span class="text-bold">Recarregar</span>
									</div>
								</button>
							</div>
							</div>
						</div>

						<div class="columns no-gap">
							<div class="span-3 light-bg bd-r height-calc-h-i ov-h flex fd-c">
							<div class="partner-integrations-search-bar">
								<form @submit.prevent class="partner-integrations-search-form">
									<search-icon/>

									<input
										v-model="processSearch"
										type="text"
										placeholder="Pesquisar Processo"
									/>
								</form>

								<drop-down contentPosition="right" :label="LabelFilter" buttonSize="md" :content-width="300" v-if="filteredProcesses.length > 0">
									<template #content>
										<div class="p-3 flex fd-c fgap1">
											<v-radio name="filter" label="Recentes" radioValue="RECENT" v-model="sortFilter" @input="sortProcesses" />
											<v-radio name="filter" label="Processos não Visualizados" radioValue="UNREADED" v-model="sortFilter" @input="sortProcesses" />
											<v-radio name="filter" label="Processos Visualizados" radioValue="READED" v-model="sortFilter" @input="sortProcesses" />
											<v-radio name="filter" label="Itens (dados) não visualizados" radioValue="ITENS_NOT_READED" v-model="sortFilter" @input="sortProcesses" />
											<v-radio name="filter" label="Processo Urgente" radioValue="PROCESS_IS_URGENT" v-model="sortFilter" @input="sortProcesses" />
										</div>
									</template>
								</drop-down>
							</div>

							<ul class="process-list">
								<!-- No Results -->
								<li
								class="pd-10 text-center flex fd-c jc-c no-hover"
								style="min-height: 250px"
								v-if="filteredProcesses.length == 0"
								>
								<p class="text-bold mb-0 text-dark">
									Nenhum processo com integração disponível no momento
								</p>
								</li>
								<!-- No Results -->

								<template v-if="filteredProcesses.length > 0">
								<li
									v-for="process in filteredProcesses"
									:key="process.gescomexId"
									:class="{
									active: process.identification === selectedProcess
									}"
									:id="`process-anchor-${process.gescomexId}`"
								>
									<a href="#" @click.prevent="getProcessData(process.identification, process.gescomexId)">
									<div class="flex ai-c fgap1 jc-sb">
										<div class="flex ai-c fgap1">
											<p class="mb-0 text-dark tx-16 flex ai-c">
												<strong>{{ process.identification }}</strong>
											</p>
											<span class="text-tag-thin text-dark">
												<calendar-icon :size="13"/>
												{{ process.lastDataSendedAt | formatDate }}
											</span>
											<span class="text-tag-thin float-right bg-warning text-dark" v-if="process.unviewedDataCount > 0">
												{{ process.unviewedDataCount }} itens não visualizados.
											</span>
										</div>
										<div class="flex ai-c fgap1">
											<i class="fa fa-flag tx-primary mg-t-0 mg-r-5 tx-danger" v-if="process.urgent === true"  v-tooltip="'Urgente'"></i>
										</div>
									</div>
									<div class="mt-1">
										<span class="text-dark uppercase tx-16">{{ process.customerName }}</span>
										<span> / </span>
										<span class="text-dark text-bold">{{ process.forwarderName }}</span>
									</div>
									<div v-if="process.viewed">
										<span class="text-dark"><i class="fa fa-eye text-primary mr-1"></i> Visualizado pela última vez em {{ process.isViewedAt | formatDate }} por {{ process.isViewedBy }} </span>
									</div>
									<div v-else>
										<span><i class="fa fa-exclamation-triangle text-warning"></i> Não visualizado</span>
									</div>
									</a>
								</li>
								</template>
							</ul>
							</div>

							<div class="span-5 p-2 height-calc-h-i ov-h flex fd-c offwhite-bg">
								<div class="integrations-list-header white-bg flex ph-2 pv-2 mb-2 fd-c" v-if="selectedProcess">
									<div class="flex text-dark mb-2 ai-c jc-sb">
										<p class="mb-0 text-bold text-md" v-if="selectedProcess">{{ selectedProcess }}</p>

										<button
											type="button"
											class="crm-button small"
											:disabled="crawlerManualBlocked"
											@click.prevent="enqueueManualCrawlerQuery"
											v-tooltip="{
												content: crawlerManualTooltip,
												class: 'tooltip-custom tooltip-other-custom'
											}"
										>
											<span class="text-bold">Consultar Tracking</span>
										</button>
									</div>
									<div class="flex jc-sb">
										<div class="text-dark">
											<p class="mb-0 text-thin text-uppercase text-lt">Nome do Forwarder</p>
											<p class="mb-0 text-bold">{{ selectedProcessData?.forwarderName ?? 'N/I' }}</p>
										</div>
										<div class="text-dark">
											<p class="mb-0 text-thin text-uppercase text-lt">Urgente</p>
											<p class="mb-0 text-bold">{{ selectedProcessData?.urgent ? 'Sim' : 'Não' }}</p>
										</div>
										<div class="text-dark">
											<p class="mb-0 text-thin text-uppercase text-lt">Via de Transporte</p>
											<p class="mb-0 text-bold">{{ selectedProcessData?.wayOfTransport ?? 'N/I' }}</p>
										</div>
										<div class="text-dark">
											<p class="mb-0 text-thin text-uppercase text-lt">Tipo de Embarque</p>
											<p class="mb-0 text-bold">{{ selectedProcessData?.typeOfBoarding ?? 'N/I' }}</p>
										</div>
									</div>    
								</div>
								<div class="integrations-list-header white-bg flex ai-c jc-sb fgap2 ph-1 pv-1" v-if="false">
									<div class="text-center text-dark flex1">
										<p class="mb-0 text-thin text-nm">DADOS <span class="mb-0 text-bold text-nm">RECEBIDOS</span></p>
										<!-- <p class="mb-0 text-bold text-nm">RECEBIDOS</p> -->
									</div>
									<div class="flex1"></div>
									<div class="text-center text-dark flex1">
										<p class="mb-0 text-thin text-nm">DADOS <span class="mb-0 text-bold text-nm">ATUAIS</span></p>
										<!-- <p class="mb-0 text-bold text-nm">ATUAIS</p> -->
									</div>
								</div>

							<ul class="integrations-list pt-2">
								<!-- No Results -->
								<li
								v-if="processData.length == 0"
								class="pd-10 text-center flex fd-c jc-c no-border"
								style="min-height: 250px"
								>
								<p
									class="text-bold mb-0 text-dark"
									style="position: relative; z-index: 8"
								>
									Nenhuma integração disponível no momento
								</p>
								</li>
								<!-- No Results -->

								<template v-if="processData.length > 0">
									<li class="flex jc-sb gap2 pb-2 pt-2 ph-1 text-dark bg-white">
										<div class="received text-center">
											<p class="mb-0 text-thin text-nm">DADOS <span class="mb-0 text-bold text-nm">RECEBIDOS</span></p>
										</div>
										<div class="">

										</div>
										<div class="actual text-center">
											<p class="mb-0 text-thin text-nm">DADOS <span class="mb-0 text-bold text-nm">ATUAIS</span></p>
										</div>
									</li>
								<li
									v-for="(data, key) in processData"
									:key="key"
									class="flex jc-sb gap2 pb-2 pt-4 mt-2 ph-1"
									:class="data.STATUS === 'INCONSISTENCY' ? 'inconsistency' : 'bg-white'"
								>
									<div class="received bd br-10 p-2 pt-3 bg-white relative">
									<div
										class="item-head"
										:class="data.SENDED.approved === true ? 'dark' : ''"
									>
										{{ data.SENDED.field | formatField }}
									</div>

									<div class="item-content pt-2 text-center">
										<p class="text-md text-bold mb-0"
										:class="data.SENDED.approved === true ? 'text-success' : 'text-dark'">
										{{ getDataValue(data.SENDED) }}
										</p>
										<p class="mb-0">
										Enviado por <strong>{{ formatSendedBy(data.SENDED.sendedBy) }}</strong>
										</p>
										<p class="mb-2">
										Em <strong>{{ data.SENDED.sendedAt | formatDate }}</strong>
										</p>
										<span class="text-status danger"
											v-if="data.STATUS === 'INCONSISTENCY' && ((Object.keys(data.SENDED.approved).length === 0 && data.SENDED.approved.constructor === Object) || data.SENDED.approved == null)">
										INCONSISTÊNCIAS
										</span>
										<span class="text-status warning"
											v-if="data.STATUS !== 'INCONSISTENCY' && Object.keys(data.SENDED.approved).length === 0 && data.SENDED.approved.constructor === Object">
										PENDENTE
										</span>
										<span class="text-status danger" v-if="data.SENDED.approved === false">
										REJEITADO
										</span>
										<span class="text-status success" v-if="data.SENDED.approved === true">
										INTEGRADO
										</span>
										
										<div class="justification">
											
											<a 
												v-if="data.SENDED.justification !== null && data.SENDED.justification !== 'null'" 
												href="#" 
												class="justification-btn" 
												@click.prevent="openJustification(data)"
											>
												<i class="fa fa-info"></i>
											</a>
											<div v-if="data?.SENDED?.sendedBy && data.SENDED.sendedBy === 'SEARATES'" 
												class="justification-btn-searates" 
												style="cursor: help;"
											>
												<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" 
												v-tooltip="{
														content: 'Integração do Searates: Plataforma que oferece rastreamento em tempo real de cargas internacionais, integrando dados de diversas transportadoras e armadores.', 
														class: 'tooltip-custom tooltip-other-custom'
													}"
												fill="#104375"><path d="M160-360q-50 0-85-35t-35-85q0-50 35-85t85-35v-80q0-33 23.5-56.5T240-760h120q0-50 35-85t85-35q50 0 85 35t35 85h120q33 0 56.5 23.5T800-680v80q50 0 85 35t35 85q0 50-35 85t-85 35v160q0 33-23.5 56.5T720-120H240q-33 0-56.5-23.5T160-200v-160Zm200-80q25 0 42.5-17.5T420-500q0-25-17.5-42.5T360-560q-25 0-42.5 17.5T300-500q0 25 17.5 42.5T360-440Zm240 0q25 0 42.5-17.5T660-500q0-25-17.5-42.5T600-560q-25 0-42.5 17.5T540-500q0 25 17.5 42.5T600-440ZM320-280h320v-80H320v80Zm-80 80h480v-480H240v480Zm240-240Z"/></svg>
											</div>

											<div v-if="data?.SENDED?.sendedBy && data.SENDED.sendedBy === 'SOWHUB_CRAWLER'" 
												class="justification-btn-searates" 
												style="cursor: help;"
											>
												<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
													v-tooltip="{
															content: 'Integração do Crawler de Tracking: Rastreamento automatizado de processos marítimos (booking, BL master e container), com consultas periódicas conforme regras de negócio.',
															class: 'tooltip-custom tooltip-other-custom'
														}"
													fill="none" stroke="#104375" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
														<path d="M12 2v2" />
														<circle cx="12" cy="2" r="0.75" fill="#104375" stroke="none" />
														<rect x="8" y="4" width="8" height="5" rx="1.5" />
														<circle cx="10" cy="6.5" r="0.75" fill="#104375" stroke="none" />
														<circle cx="14" cy="6.5" r="0.75" fill="#104375" stroke="none" />
														<path d="M12 9v1" />
														<rect x="7" y="10" width="10" height="7" rx="1.5" />
														<path d="M7 11L2 9" />
														<path d="M7 13H1" />
														<path d="M7 15L2 17" />
														<path d="M17 11L22 9" />
														<path d="M17 13H23" />
														<path d="M17 15L22 17" />
														<path d="M9 17v4" />
														<path d="M15 17v4" />
													</svg>
												</div>
											
											</div>
										</div>
									</div>

									<div class="actions flex fd-c fgap1 ai-c">
									<div class="number-indicator">{{ key + 1 }}</div>
									<div
										v-if="Object.keys(data.SENDED.approved).length === 0 && data.SENDED.approved.constructor === Object">
										<a
										v-if="data.SENDED.field !== 'CONTAINERS'"
										@click.prevent="approveProcessData(data)"
										href="#"
										class="crm-button small round block text-center"
										>
										Aprovar
										</a>
										<a
										v-else
										@click.prevent="() => checkContainers(data, data.PROCESS_ID)"
										href="#"
										class="crm-button small round block text-center"
										>
										Analisar aprovação
										</a>
										<a
										@click.prevent="rejectProcessData(data)"
										href="#"
										class="crm-button small round block text-center red mt-1"
										>
										Contestar
										</a>
									</div>
									<div v-else-if="!data.SENDED.approved">
										<span class="text-status danger useHint" style="cursor: help;">
										CONTESTADO
											<div class="hint flex fd-c gap1">
												<div v-if="data.SENDED.approveRejectMotivation" style="white-space: nowrap">
													<span style="text-decoration: underline;">Motivo</span>: {{ rejectMotivationText(data.SENDED.approveRejectMotivation) }}
												</div>
												<div v-if="data.SENDED.approveRejectJustification">
													<span style="text-decoration: underline;">Justificativa</span>: {{ data.SENDED.approveRejectJustification }}
												</div>
												<div class="text-center" v-if="!data.SENDED.approveRejectJustification && !data.SENDED.approveRejectMotivation">
													Sem motivo e justificativa
												</div>
											</div>
										</span>
									</div>
									<div v-else>
										<span v-tooltip="{ content: data.SENDED.approveRejectJustification || 'Sem justificativa', class: 'tooltip-custom-success'}" class="text-status success" style="cursor: help;">
										APROVADO
										</span>
									</div>
									</div>

									<div class="actual white-bg bd br-10 p-2 pt-3">
									<div
										class="item-head"
										:class="data.SENDED.approved === true ? 'dark' : ''"
									>
										{{ data.SENDED.field | formatField }}
									</div>

									<div class="item-content pt-2 text-center">
										<p class="text-md text-bold mb-0"
										:class="data.SENDED.approved === true ? 'text-success' : 'text-dark'">
										<span v-if="data.DESTINATION_PORT !== null && data.DESTINATION_PORT">{{ data.CURRENT }}</span>
										<span v-else>{{ data.CURRENT ? getCurrentDataValue(data) : '-' }}</span>
										</p>
										<div
										v-if="(data.SENDED.approved === true || !data.SENDED.approved) && data.SENDED.integratedBy.constructor !== Object">
										<p class="mb-0">
											Enviado por <strong>{{ data.SENDED.integratedBy }}</strong>
										</p>
										<p class="mb-2">
											Em <strong>{{ data.SENDED.integratedAt | formatDate }}</strong>
										</p>
										</div>
										<div v-else>
										<p class="mb-2">-</p>
										</div>
										<check-icon v-if="data.SENDED.approved === true" color="#3B9B28"/>
										<x-mark-icon v-else-if="data.SENDED.approved === false" color="red">-</x-mark-icon>
										<span v-else>NENHUMA INTEGRAÇÃO RECEBIDA</span>
									</div>
									</div>
								</li>
								</template>
							</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="registrations-main" v-if="action === 'logs'">
			<div class="dash-headline-two">
				<div class="d-flex align-items-center">
					<h2 class="tx-inverse mg-b-0">
						Processos com erro na integração com o Searates
					</h2>
				</div>
			</div>

			<hr class="mb-1" />
			
			<PartnerIntegrationsFilter @find-processes-with-data="getProcessesWithErrors($event)" labelButton="FILTRAR"/>

			<hr class="mb-4" />

			<div class="ov-h">
				<div v-if="processesWithErrors.length > 0">
					<TableSSR 
						:columns="tableColumns" 
						:tableData="processesWithErrors"
						:totalRecords="processesWithErrors.length"
						:table-config="{
							useSearch: true,
							centeredCell: false,
							showRecords: true,
							paginationTop: true,
							typeSearch: 'list',
							showPerPageTop: true,
							showPerPageBottom: true,
							perPage: perPage,
							searchPlaceholder: 'Pesquisar referência',
						}"
						:searchFilter="processId"
						:initialSortConfig="initialSortConfig"
						@perPageChange="perPageChange"
						@pageChange="perPageChange"
						:currentPage="currentPage"
					>
						<template #processIdentification="{ item }">
							<div v-if="'processIdentification' in item">
								<a class="text-color-primary text-bold" :href="`/operational/imp/desk?showProcess=true&identification=${item.trackingData[0].process.identification}`" target="_blank"> 
									{{ item.processIdentification }}
								</a>
							</div>
						</template>
						<template #step="{ item }">
							<div v-if="'step' in item.trackingData[0].process" class="text-center">
								<p 
									v-if="item.trackingData[0].process.step.id" 
									style="padding: 5px 10px; border-radius: 5px; text-transform: uppercase;"
									:style="{ color: item.trackingData[0].process.step.textColor, backgroundColor: item.trackingData[0].process.step.color }"
								> 
									{{ item.trackingData[0].process.step.name }}
								</p>
								<p v-else> - </p>
							</div>
						</template>
						<template #completeName="{ item }">
							<div v-if="'completeName' in item.trackingData[0].process.customer">
								<p v-if="item.trackingData[0].process.customer.completeName" class="flex fd-c"> 
									<span class="text-color-primary" style="text-transform: uppercase;">{{ item.trackingData[0].process.customer.completeName }}</span>
									<small v-if="item.trackingData[0].process.customer.federalID">{{ item.trackingData[0].process.customer.federalID }}</small>
								</p>
								<p v-else> - </p>
							</div>
						</template>
						<template #[`trackingData.0.createdAt`]="{ item }">
							<div v-if="'createdAt' in item.trackingData[0]" class="text-center" style="min-width: 170px">
								<p v-if="item.trackingData[0].createdAt"> 
									{{ formatDateTimeFunction(item.trackingData[0].createdAt) }}
								</p>
								<p v-else> - </p>
							</div>
						</template>
						<template #trackingType="{ item }">
							<div v-if="'trackingType' in item.trackingData[0]" class="text-center">
								<p v-if="item.trackingData[0].trackingType"> 
									{{ item.trackingData[0].trackingType }}
								</p>
								<p v-else> - </p>
							</div>
						</template>
						<template #trackingNumber="{ item }">
							<div v-if="'trackingNumber' in item.trackingData[0]" class="text-center">
								<p v-if="item.trackingData[0].trackingNumber"> 
									{{ item.trackingData[0].trackingNumber }}
								</p>
								<p v-else> - </p>
							</div>
						</template>
						<template #motivation="{ item }">
							<div v-if="'content' in item.trackingData[0]">
								<p v-if="item.trackingData[0].content"> 
									{{ item.trackingData[0].content | formatMotivation }}
								</p>
								<p v-else> - </p>
							</div>
						</template>
						<template #errors="{ item }">
							<div v-if="item.trackingData.length > 0" class="text-center">
								<span class="badge badge-danger text-bold" style="padding: 10px 10px; width: 40px;"> 
									{{ item.trackingData.length }}
								</span>
							</div>
						</template>
						<template #actions="{ item }">
							<div v-if="item.trackingData.length > 0" class="flex jc-c">
								<button class="edit-button" style="cursor: pointer;" @click="openErrorsModal(item)">
									<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"/></svg>
								</button>
							</div>
						</template>
					</TableSSR>
				</div>
				<div v-else class="text-center pd-t-30 pd-b-30">
					<h3>Nenhum processo encontrado</h3>
				</div>

			</div>
		</div>

		<div class="registrations-main" v-if="action === 'crawler-errors'">
			<div class="dash-headline-two">
				<div class="d-flex align-items-center">
					<h2 class="tx-inverse mg-b-0">
						Erros de execução do Crawler de Tracking
					</h2>
				</div>
			</div>

			<hr class="mb-1" />

			<PartnerIntegrationsFilter
				@find-processes-with-data="onCrawlerErrorsFilter($event)"
				labelButton="FILTRAR"
				:showIdentification="true"
				:hideStep="true"
				:showCustomsTeam="true"
				:showDateRange="true"
			/>

			<hr class="mb-4" />

			<div class="ov-h">
				<TableSSR
					v-if="crawlerErrorsData.content && crawlerErrorsData.content.length > 0"
					:columns="crawlerErrorsColumns"
					:tableData="crawlerErrorsData.content"
					:totalRecords="crawlerErrorsData.totalElements"
					:current-page="crawlerErrorsPage"
					:last-page="crawlerErrorsData.totalPages"
					@pageChange="onCrawlerErrorsPageChange"
					@perPageChange="onCrawlerErrorsPerPageChange"
					:table-config="{
						useSearch: false,
						centeredCell: false,
						showRecords: true,
						paginationTop: true,
						typeSearch: 'query',
						showPerPageTop: true,
						showPerPageBottom: true,
						perPage: crawlerErrorsPerPage,
					}"
				>
					<template #formattedReference="{ item }">
						<div v-if="item.formattedReference || item.processIdentification">
							<a
								class="text-color-primary text-bold"
								:href="`/operational/imp/desk?showProcess=true&identification=${item.processIdentification}`"
								target="_blank"
							>
								{{ item.formattedReference || item.processIdentification }}
							</a>
						</div>
						<p v-else>-</p>
					</template>
					<template #rule="{ item }">
						<div class="text-center">
							<p v-if="item.rule" style="display: inline-flex; align-items: center; gap: 8px;">
								{{ item.rule }}
								<span
									v-if="getCrawlerRuleDescription(item.rule)"
									class="crawler-rule-info-trigger crawler-rule-info-trigger--grid"
									v-tooltip="{
										content: getCrawlerRuleDescription(item.rule),
										class: 'tooltip-custom tooltip-other-custom',
										placement: 'top',
									}"
								>
									<i class="fa fa-info "></i>
								</span>
							</p>
							<p v-else>-</p>
						</div>
					</template>
					<template #trackingType="{ item }">
						<div class="text-center">
							<p v-if="item.trackingType">{{ item.trackingType }}</p>
							<p v-else>-</p>
						</div>
					</template>
					<template #trackingNumber="{ item }">
						<div class="text-center">
							<p v-if="item.trackingNumber">{{ item.trackingNumber }}</p>
							<p v-else>-</p>
						</div>
					</template>
					<template #messageStatus="{ item }">
						<div class="text-center">
							<span
								v-if="item.messageStatus"
								class="badge text-bold"
								:class="item.messageStatus.toLowerCase() === 'error' ? 'badge-danger' : 'badge-warning'"
								style="padding: 5px 10px; text-transform: uppercase;"
							>
								{{ item.messageStatus }}
							</span>
							<p v-else>-</p>
						</div>
					</template>
					<template #errorMessage="{ item }">
						<p v-if="item.errorMessage || item.executionMessage">
							{{ item.errorMessage || item.executionMessage }}
						</p>
						<p v-else>-</p>
					</template>
					<template #noUsableData="{ item }">
						<div class="text-center">
							<span
								v-if="item.noUsableData === true"
								class="config-table-tag text-center danger"
							>
								Sim
							</span>
							<span
								v-else-if="item.noUsableData === false"
								class="config-table-tag text-center success"
							>
								Não
							</span>
							<p v-else>-</p>
						</div>
					</template>
					<template #createdAt="{ item }">
						<div class="text-center" style="min-width: 170px">
							<p v-if="item.createdAt">{{ formatDateTimeFunction(item.createdAt) }}</p>
							<p v-else>-</p>
						</div>
					</template>
					<template #actions="{ item }">
						<div class="flex jc-c">
							<button class="edit-button" style="cursor: pointer;" @click="openCrawlerErrorModal(item)">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"/></svg>
							</button>
						</div>
					</template>
				</TableSSR>
				<div v-else class="text-center pd-t-30 pd-b-30">
					<h3>Nenhum erro encontrado</h3>
				</div>
			</div>
		</div>

		<div class="registrations-main" v-if="action === 'crawler-executions'">
			<div class="dash-headline-two">
				<div class="d-flex align-items-center">
					<h2 class="tx-inverse mg-b-0">
						Execuções bem-sucedidas do Crawler de Tracking
					</h2>
				</div>
			</div>

			<hr class="mb-1" />

			<PartnerIntegrationsFilter
				@find-processes-with-data="onCrawlerExecutionsFilter($event)"
				labelButton="FILTRAR"
				:showIdentification="true"
				:hideStep="true"
				:showCustomsTeam="true"
				:showDateRange="true"
			/>

			<hr class="mb-4" />

			<div class="ov-h">
				<TableSSR
					v-if="crawlerExecutionsData.content && crawlerExecutionsData.content.length > 0"
					:columns="crawlerExecutionsColumns"
					:tableData="crawlerExecutionsData.content"
					:totalRecords="crawlerExecutionsData.totalElements"
					:current-page="crawlerExecutionsPage"
					:last-page="crawlerExecutionsData.totalPages"
					@pageChange="onCrawlerExecutionsPageChange"
					@perPageChange="onCrawlerExecutionsPerPageChange"
					:table-config="{
						useSearch: false,
						centeredCell: false,
						showRecords: true,
						paginationTop: true,
						typeSearch: 'query',
						showPerPageTop: true,
						showPerPageBottom: true,
						perPage: crawlerExecutionsPerPage,
					}"
				>
					<template #formattedReference="{ item }">
						<div v-if="item.formattedReference || item.processIdentification">
							<a
								class="text-color-primary text-bold"
								:href="`/operational/imp/desk?showProcess=true&identification=${item.processIdentification}`"
								target="_blank"
							>
								{{ item.formattedReference || item.processIdentification }}
							</a>
						</div>
						<p v-else>-</p>
					</template>
					<template #rule="{ item }">
						<div class="text-center">
							<p v-if="item.rule" style="display: inline-flex; align-items: center; gap: 8px;">
								{{ item.rule }}
								<span
									v-if="getCrawlerRuleDescription(item.rule)"
									class="crawler-rule-info-trigger crawler-rule-info-trigger--grid"
									v-tooltip="{
										content: getCrawlerRuleDescription(item.rule),
										class: 'tooltip-custom tooltip-other-custom',
										placement: 'top',
									}"
								>
									<i class="fa fa-info"></i>
								</span>
							</p>
							<p v-else>-</p>
						</div>
					</template>
					<template #trackingType="{ item }">
						<div class="text-center">
							<p v-if="item.trackingType">{{ item.trackingType }}</p>
							<p v-else>-</p>
						</div>
					</template>
					<template #trackingNumber="{ item }">
						<div class="text-center">
							<p v-if="item.trackingNumber">{{ item.trackingNumber }}</p>
							<p v-else>-</p>
						</div>
					</template>
					<template #messageStatus="{ item }">
						<div class="text-center">
							<span
								v-if="item.messageStatus"
								class="badge text-bold"
								:class="item.messageStatus.toLowerCase() === 'error' ? 'badge-danger' : 'badge-warning'"
								style="padding: 5px 10px; text-transform: uppercase;"
							>
								{{ item.messageStatus }}
							</span>
							<p v-else>-</p>
						</div>
					</template>
					<template #errorMessage="{ item }">
						<p v-if="item.errorMessage || item.executionMessage">
							{{ item.errorMessage || item.executionMessage }}
						</p>
						<p v-else>-</p>
					</template>
					<template #createdAt="{ item }">
						<div class="text-center" style="min-width: 170px">
							<p v-if="item.createdAt">{{ formatDateTimeFunction(item.createdAt) }}</p>
							<p v-else>-</p>
						</div>
					</template>
					<template #actions="{ item }">
						<div class="flex jc-c">
							<button class="edit-button" style="cursor: pointer;" @click="openCrawlerErrorModal(item)">
								<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"/></svg>
							</button>
						</div>
					</template>
				</TableSSR>
				<div v-else class="text-center pd-t-30 pd-b-30">
					<h3>Nenhuma execução encontrada</h3>
				</div>
			</div>
		</div>

		<v-modal
		@requestClose="closeJustification"
		:handler="justificationModalOpen"
		title="Justificativa do envio"
		description=""
		id="modalJustification"
		:width="700"
		:height="40"
		>
		<template #content>
			<p>{{ justificationData.SENDED.justification }}</p>
		</template>
		</v-modal>

		<v-modal
		title="Analisar containers"
		:description="`Compare os containers cadastrados com os enviados entes de aprovar`"
		:height="40"
		:width="800"
		:handler="openModalCheckContainers"
		@requestClose="openModalCheckContainers = false"
		>
		<template #content>
			<div>
			<div class="alert alert-warning">
				<i class="fa fa-exclamation-triangle mr-2"></i> Atenção! ao aprovar estas informações, os dados dos
				containers serão alterados.
			</div>
			<span class="text-info"><i class="fa fa-info-circle"></i> Cálculo de Deadline: Chegada + Freetime - 1</span>
			<div class="col-12 mt-2">
			</div>
			<div class="row">
				<div class="col-6">
				<table class="table table-striped table-hover table-bordered">
					<thead>
					<tr>
					<th class="text-center">Recebidos</th>
					</tr>
					</thead>
					<tbody>
					<tr v-for="container in containersSended" :key="container.number">
					<td>
						<p><strong>Container: </strong>{{ container.container }}</p>
						<p><strong>Chegada: </strong>{{ container.arrival ? formatDateFunction(container.arrival) : 'N/A' }}
						</p>
						<p><strong>Freetime: </strong>{{ container.freetime ? container.freetime : 'N/A' }}</p>
						<p v-if="container.arrival && container.freetime">
						<strong>Deadline: </strong> {{ calculateContainerDeadline(container.arrival, (container.freetime - 1)) }} <span class="text-thin">(calculado automaticamente)</span>
						</p>
					</td>
					</tr>
					</tbody>
				</table>
				</div>
				<div class="col-6">
				<table class="table table-striped table-hover table-bordered">
					<thead>
					<tr>
					<th class="text-center">Atuais</th>
					</tr>
					</thead>
					<tbody>
					<tr v-if="containersCurrent.length == 0">
					<td class="text-center">
						Nenhum container cadastrado atualmente.
					</td>
					</tr>
					<template v-else>
					<tr v-for="container in containersCurrent" :key="container.number">
						<td>
						<p><strong>Container: </strong>{{ container.container }}</p>
						<p><strong>Chegada: </strong>{{
							container.arrival ? formatDateFunction(container.arrival) : 'N/A'
							}}
						</p>
						<p><strong>Freetime: </strong>{{ container.freetime ? container.freetime : 'N/A' }}</p>
						<p><strong>Deadline: </strong>{{
							container.deadline ? formatDateFunction(container.deadline) : 'N/A'
							}}</p>
						</td>
					</tr>
					</template>
					</tbody>
				</table>
				</div>
			</div>
			</div>
		</template>
		<template #footer="{ closeModal }">
			<div class="d-flex align-items-center justify-content-center">
			<button class="crm-button danger round mr-2" id="closeModalContainers" @click.prevent="closeModal">CANCELAR
			</button>
			<button class="crm-button round" @click.prevent="approveProcessData(containersDataSelected)">APROVAR
				CONTAINERS RECEBIDOS
			</button>
			</div>
		</template>
		</v-modal>

		<v-modal title="Alteração de Datas e Histórico"
			:description="`Alterar demais datas do Processo e registrar Histórico`"
			:handler="modalHistoryOpen"
			@requestClose="closeHistoryModal"
			:height="70"
			:width="900"
			classModify="remove-overflow"
		>
		<template #content>
			<form action="" class="form-layout form-layout-2">
			<span>Deseja Alterar algum outro campo de Data?</span>
			<div class="row no-gutters mt-2">
				<div class="form-group col-md-3">
				<label class="form-control-label"> ETD Inicial </label>
				<div class="input-group-solved">
					<div class="input-group-solved-before">
					<i class="fa fa-calendar op-5"></i>
					</div>
					<div class="input-group-solved-center">
					<date-picker v-model="formHistory.initialDatesETD" name="initialDatesETD" inputName="initialDatesETD"
								class="form-control" format="DD/MM/YY" lang="pt-br"
								placeholder="Selecione"></date-picker>
					</div>
				</div>
				</div>
				<div class="form-group col-md-3 bd-l-0-force">
				<label class="form-control-label"> ETD </label>
				<div class="input-group-solved">
					<div class="input-group-solved-before">
					<i class="fa fa-calendar op-5"></i>
					</div>
					<div class="input-group-solved-center">
					<date-picker v-model="formHistory.datesETD" name="datesETD" inputName="datesETD" class="form-control"
								format="DD/MM/YY" lang="pt-br" placeholder="Selecione"></date-picker>
					</div>
				</div>
				</div>
				<div class="form-group col-md-3 bd-l-0-force">
				<label class="form-control-label"> ETA </label>
				<div class="input-group-solved">
					<div class="input-group-solved-before">
					<i class="fa fa-calendar op-5"></i>
					</div>
					<div class="input-group-solved-center">
					<date-picker v-model="formHistory.datesETA" name="datesETA" inputName="datesETA" class="form-control"
								format="DD/MM/YY" lang="pt-br" placeholder="Selecione"></date-picker>
					</div>
				</div>
				</div>
				<div class="form-group col-md-3 bd-l-0-force">
				<label class="form-control-label"> Entrega Cliente </label>
				<div class="input-group-solved">
					<div class="input-group-solved-before">
					<i class="fa fa-calendar op-5"></i>
					</div>
					<div class="input-group-solved-center">
					<date-picker v-model="formHistory.datesEstimatedCustomerDeliverDate"
								name="datesEstimatedCustomerDeliverDate" inputName="datesEstimatedCustomerDeliverDate"
								class="form-control" format="DD/MM/YY" lang="pt-br"
								placeholder="Selecione"></date-picker>
					</div>
				</div>
				</div>
			</div>
			<hr>
			<div class="mt-2">
				<div class="row">
				<div class="col-6">
					<label>Enviar Histórico?</label>
					<v-switch
					name="sendHistory"
					:labels="{
						checked: `Sim`,
						unchecked: `Não`,
						}"
					v-model="formHistory.sendHistory"
					/>
				</div>
				<div class="col-6" v-if="formHistory.sendHistory">
					<label>Visível ao Cliente?</label>
					<v-switch
					name="visibleToCustomer"
					:labels="{
						checked: `Sim`,
						unchecked: `Não`,
						}"
					v-model="formHistory.isVisibleToCustomer"
					/>
				</div>
				</div>
			</div>
			<div v-if="formHistory.sendHistory" class="mt-3">
				<virtual-select :tabindex="1" placeholder="Selecione uma Prioridade" :options="priorityOptions"
								v-model="formHistory.historyPriority"/>
			</div>
			<div class="mt-3" v-if="formHistory.sendHistory">
				<v-textarea name="historyText" label="Texto do Histórico" v-model="formHistory.historyContent"></v-textarea>
			</div>
			<hr>
			<div class="mt-2">
				<div class="form-group">
				<label class="form-control-label">Status (Situação Rápida)</label>
				<input v-model="formHistory.status" class="form-control" name="status" type="text"/>
				</div>
			</div>

			</form>
		</template>
		<template #footer>
			<div class="row justify-content-center">
			<button class="crm-button mt-2 mr-2 gray" @click.prevent="closeHistoryModal">Fechar</button>
			<button class="crm-button mt-2" @click.prevent="submitOtherDatesAndHistoryForm">Salvar</button>
			</div>
		</template>
		</v-modal>

		<v-modal
			@requestClose="closeErrorsModal"
			:handler="errorsModalOpen"
			:title="errorsModalTitle"
			description=""
			id="modalErrors"
			:width="1200"
		>
			<template #content>
				<div class="row">
					<table class="table display responsive nowrap dataTable no-footer dtr-inline tx-13 table-hover table-striped">
						<thead>
							<tr>
								<th class="text-center">Data do erro</th>
								<th class="text-center">Campo consultado</th>
								<th class="text-center">Valor consultado</th>
								<th>Motivo</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="error in errorsModalData.trackingData" :key="error.id">
								<td class="text-center">{{ formatDateTimeFunction(error.createdAt) }}</td>
								<td class="text-center">{{ error.trackingType }}</td>
								<td class="text-center">{{ error.trackingNumber }}</td>
								<td>{{ error.content | formatMotivation }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</template>
		</v-modal>

		<v-modal
			@requestClose="closeCrawlerErrorModal"
			:handler="crawlerErrorModalOpen"
			:title="crawlerErrorModalTitle"
			description=""
			id="modalCrawlerError"
			:width="1200"
			:height="75"
		>
			<template #content>
				<div v-if="crawlerErrorModalData" class="crawler-error-modal">
					<section class="crawler-error-section">
						<h4 class="crawler-error-section-title">Informações</h4>
						<div class="crawler-error-grid">
							<div class="crawler-error-field">
								<span class="crawler-error-label">Referência</span>
								<span class="crawler-error-value">{{ crawlerErrorModalData.formattedReference || crawlerErrorModalData.processIdentification || '-' }}</span>
							</div>
							<div class="crawler-error-field">
								<span class="crawler-error-label">Data</span>
								<span class="crawler-error-value">{{ crawlerErrorModalData.createdAt ? formatDateTimeFunction(crawlerErrorModalData.createdAt) : '-' }}</span>
							</div>
							<div class="crawler-error-field">
								<span class="crawler-error-label">Regra</span>
								<span class="crawler-error-value crawler-error-value--with-info">
									{{ crawlerErrorModalData.rule || '-' }}
									<span
										v-if="getCrawlerRuleDescription(crawlerErrorModalData.rule)"
										class="crawler-rule-info-trigger"
										v-tooltip="{
											content: getCrawlerRuleDescription(crawlerErrorModalData.rule),
											class: 'tooltip-custom tooltip-other-custom',
											placement: 'top',
										}"
									>
										<i class="fa fa-info"></i>
									</span>
								</span>
							</div>
							<div class="crawler-error-field">
								<span class="crawler-error-label">Sem dados utilizáveis</span>
								<span class="crawler-error-value">
									<span
										class="config-table-tag text-center"
										:class="crawlerErrorModalData.noUsableData ? 'danger' : 'success'"
									>
										{{ crawlerErrorModalData.noUsableData ? 'Sim' : 'Não' }}
									</span>
								</span>
							</div>
							<div class="crawler-error-field">
								<span class="crawler-error-label">Tipo tracking</span>
								<span class="crawler-error-value">{{ crawlerErrorModalData.trackingType || '-' }}</span>
							</div>
							<div class="crawler-error-field">
								<span class="crawler-error-label">Retry HBL enviado</span>
								<span class="crawler-error-value">
									<span
										class="config-table-tag text-center"
										:class="crawlerErrorModalData.hblRetrySent ? 'danger' : 'success'"
									>
										{{ crawlerErrorModalData.hblRetrySent ? 'Sim' : 'Não' }}
									</span>
								</span>
							</div>
							<div class="crawler-error-field">
								<span class="crawler-error-label">Nº tracking</span>
								<span class="crawler-error-value">{{ crawlerErrorModalData.trackingNumber || '-' }}</span>
							</div>
							<div class="crawler-error-field">
								<span class="crawler-error-label">Ack enviado</span>
								<span class="crawler-error-value">
									<span
										class="config-table-tag text-center"
										:class="crawlerErrorModalData.ackSent ? 'success' : 'danger'"
									>
										{{ crawlerErrorModalData.ackSent ? 'Sim' : 'Não' }}
									</span>
								</span>
							</div>
							<div class="crawler-error-field">
								<span class="crawler-error-label">Status</span>
								<span class="crawler-error-value">
									<span
										v-if="crawlerErrorModalData.messageStatus"
										class="badge text-bold crawler-error-status-badge"
										:class="getCrawlerMessageStatusClass(crawlerErrorModalData.messageStatus)"
									>
										{{ crawlerErrorModalData.messageStatus }}
									</span>
									<span v-else>-</span>
								</span>
							</div>
							<div class="crawler-error-field">
								<span class="crawler-error-label">Forwarder enviado</span>
								<span class="crawler-error-value">
									<span
										class="config-table-tag text-center"
										:class="crawlerErrorModalData.forwarderSent ? 'success' : 'danger'"
									>
										{{ crawlerErrorModalData.forwarderSent ? 'Sim' : 'Não' }}
									</span>
								</span>
							</div>
							<div class="crawler-error-field">
								<span class="crawler-error-label">Job</span>
								<span class="crawler-error-value crawler-error-value--mono">{{ crawlerErrorModalData.jobName || '-' }}</span>
							</div>
							<div class="crawler-error-field">
								<span class="crawler-error-label">Pipeline</span>
								<span class="crawler-error-value">{{ crawlerErrorModalData.pipelineId || '-' }}</span>
							</div>
							<div class="crawler-error-field">
								<span class="crawler-error-label">Message ID</span>
								<span class="crawler-error-value">{{ crawlerErrorModalData.messageId || '-' }}</span>
							</div>
						</div>
					</section>

					<section v-if="crawlerErrorModalData.errorMessage" class="crawler-error-section">
						<h4 class="crawler-error-section-title">Mensagem de erro</h4>
						<div class="crawler-error-alert crawler-error-alert--danger">
							{{ crawlerErrorModalData.errorMessage }}
						</div>
					</section>

					<section v-if="crawlerErrorModalData.executionMessage" class="crawler-error-section">
						<h4 class="crawler-error-section-title">Mensagem de execução</h4>
						<div class="crawler-error-alert">
							{{ crawlerErrorModalData.executionMessage }}
						</div>
					</section>

					<section v-if="crawlerErrorModalData.resultPayload" class="crawler-error-section">
						<div class="crawler-error-payload-header">
							<h4 class="crawler-error-section-title mb-0">Result Payload</h4>
							<button
								type="button"
								class="crm-button small gray"
								@click="copyCrawlerPayloadToClipboard(crawlerErrorModalData.resultPayload)"
							>
								Copiar
							</button>
						</div>
						<pre class="crawler-error-payload">{{ formatJsonPayload(crawlerErrorModalData.resultPayload) }}</pre>
					</section>

					<section v-if="crawlerErrorModalData.forwarderSentData" class="crawler-error-section">
						<div class="crawler-error-payload-header">
							<h4 class="crawler-error-section-title mb-0">Dados enviados ao forwarder</h4>
							<button
								type="button"
								class="crm-button small gray"
								@click="copyCrawlerPayloadToClipboard(crawlerErrorModalData.forwarderSentData)"
							>
								Copiar
							</button>
						</div>
						<pre class="crawler-error-payload">{{ formatJsonPayload(crawlerErrorModalData.forwarderSentData) }}</pre>
					</section>
				</div>
			</template>
			<template #footer="{ closeModal }">
				<div class="row justify-content-end">
					<button class="crm-button gray" @click.prevent="closeModal">Fechar</button>
				</div>
			</template>
		</v-modal>

	</div>	
</template>

<script>
import MenuPartnerIntegrations from '@/views/operational/integration/MenuPartnerIntegrations.vue';
import DatePicker from "vue2-datepicker";
import {SearchIcon, CalendarIcon} from "@/components/crm/Icons";
import RefreshIcon from "@/components/icons/Refresh.vue";
import CheckIcon from "@/components/icons/Check.vue";
import XMarkIcon from "@/components/icons/XMark.vue";
import PartnerIntegrationsFilter from "@/components/PartnerIntegrationsFilter.vue";

import VModal from "@/components/VModal.vue";

import config from "@/config.js";
import Axios from 'axios';

import moment from 'moment';
import Swal from 'sweetalert2';
import VirtualSelect from "@/components/VirtualSelect.vue";
import VSwitch from "@/components/VSwitch.vue";
import VTextarea from "@/components/VTextarea.vue";
import DropDown from '@/components/DropDown.vue';
import VRadio from '@/components/VRadio.vue';
import ProcessService from "@/services/ProcessService";
import { swal } from "vue-swal";
import TableSSR from "@/components/TableSSR.vue";

const SOWHUB_CRAWLER_RULE_DESCRIPTIONS = {
	REGRA_1: 'Consulta 1x ao dia os processos em Booking que não possuem ETD e embarque preenchidos',
	REGRA_2_ITEM_1: 'Consulta 1x na semana os processos que estão em Booking, não possuem embarque preenchido e se faltar mais do que 7 dias para ETD',
	REGRA_2_ITEM_2: 'Consulta 1x ao dia os processos que estão em Booking, não possuem embarque preenchido e se faltar menos do que 7 dias para ETD',
	REGRA_2_ITEM_3: 'Consulta 2x ao dia os processos que estão em Booking, não possuem embarque preenchido onde a data atual é a mesma ou menor que a data do ETD',
	REGRA_3: 'Consulta 1x ao dia processos que estão sem ETA e sem chegada',
	REGRA_4_ITEM_1: 'Consulta 1x na semana os processos em trânsito sem data de chegada faltando 7 dias ou mais para a ETA',
	REGRA_4_ITEM_2: 'Consulta 1x ao dia os processos em trânsito sem data de chegada faltando menos de 7 dias para a ETA',
	REGRA_4_ITEM_3: 'Consulta 3x ao dia os processos que estão em Trânsito, não possuem chegada preenchida onde a data atual é a mesma ou menor que a data do ETA',
};

export default {
  name: "PartnerIntegrations",
  components: {
    DatePicker,
    VSwitch,
    VirtualSelect,
    XMarkIcon,
    PartnerIntegrationsFilter,
    RefreshIcon,
    SearchIcon,
    CalendarIcon,
    CheckIcon,
    VModal,
    VTextarea,
    DropDown,
    VRadio,
	MenuPartnerIntegrations,
	TableSSR
  },
  data() {
    return {
		tableColumns: [
			{
				label: 'Referência',
				field: 'processIdentification',
			},
			{
				label: 'Etapa',
				field: 'step',
				class: 'text-center',
			},
			{
				label: 'Cliente',
				field: 'completeName',
			},
			{
				label: 'Data do último erro',
				field: 'trackingData.0.createdAt',
				class: 'text-center',
				sortable: true,
				initialSort: true,
				initialSortDirection: 'desc'
			},
			{
				label: 'Campo consultado',
				field: 'trackingType',
				class: 'text-center',
			},
			{
				label: 'Valor consultado',
				field: 'trackingNumber',
				class: 'text-center',
			},
			{
				label: 'Motivo',
				field: 'motivation',
			},
			{
				label: 'Qtd. de erros',
				field: 'errors',
				class: 'text-center',
			},
			{
				label: 'Ações',
				field: 'actions',
				class: 'text-center',
			},
		],
		errorsModalOpen: false,
		errorsModalData: [],
		errorsModalTitle: '',
		action: this.$route.params.action ?? null,
		processId: this.$route.query.processId ?? '',
		processesWithErrors: [],
		sortFilter: "RECENT",
		processes: [],
		processData: [],
		forwarderSelected: null,
		openModalCheckContainers: false,
		containersSended: [],
		containersCurrent: [],
		containersDataSelected: null,
		last10Quotations: [],
		justificationModalOpen: false,
		justificationData: null,
		rejectMotivation:[
			{
				label: 'Valores incorretos ou desatualizados',
				value: 'INCORRECT_OUTDATED',
			},
			{
				label: 'Outros motivos internos',
				value: 'OTHER_INTERNAL_MOTIVATION',
			},
		],
		selectedProcess: null,
		selectedProcessData: {},
		selectedProcessId: null,
		processSearch: '',
		modalHistoryOpen: false,
		fieldToApprove: null,
		hoverRefresh: '#104375',
		crawlerManualRetryAt: null,
		crawlerManualRetryTimer: null,
		formHistory: {
			processId: null,
			datesETA: null,
			datesETD: null,
			initialDatesETD: null,
			datesEstimatedCustomerDeliverDate: null,
			sendHistory: false,
			historyPriority: null,
			historyContent: null,
			isVisibleToCustomer: false,
			status: "",
		},
		stateFilters: {},
		priorityOptions: [
			{
			label: 'Normal',
			value: 'NORMAL',
			},
			{
			label: 'Importante',
			value: 'IMPORTANTE',
			},
			{
			label: 'Urgente',
			value: 'URGENTE',
			},
		],
		perPage: 100,
		currentPage: 1,
		crawlerErrorsColumns: [
			{
				label: 'Referência',
				field: 'formattedReference',
			},
			{
				label: 'Regra',
				field: 'rule',
				class: 'text-center',
			},
			{
				label: 'Tipo tracking',
				field: 'trackingType',
				class: 'text-center',
			},
			{
				label: 'Nº tracking',
				field: 'trackingNumber',
				class: 'text-center',
			},
			{
				label: 'Status',
				field: 'messageStatus',
				class: 'text-center',
			},
			{
				label: 'Motivo',
				field: 'errorMessage',
			},
			{
				label: 'Sem dados',
				field: 'noUsableData',
				class: 'text-center',
			},
			{
				label: 'Data',
				field: 'createdAt',
				class: 'text-center',
			},
			{
				label: 'Ações',
				field: 'actions',
				class: 'text-center',
			},
		],
		crawlerErrorsData: {
			content: [],
			totalElements: 0,
			currentPage: 0,
			totalPages: 0,
			size: 20,
		},
		crawlerErrorsFilters: {},
		crawlerErrorsPage: 1,
		crawlerErrorsPerPage: 20,
		crawlerExecutionsColumns: [
			{
				label: 'Referência',
				field: 'formattedReference',
			},
			{
				label: 'Regra',
				field: 'rule',
				class: 'text-center',
			},
			{
				label: 'Tipo tracking',
				field: 'trackingType',
				class: 'text-center',
			},
			{
				label: 'Nº tracking',
				field: 'trackingNumber',
				class: 'text-center',
			},
			{
				label: 'Status',
				field: 'messageStatus',
				class: 'text-center',
			},
			{
				label: 'Motivo',
				field: 'errorMessage',
			},
			{
				label: 'Data',
				field: 'createdAt',
				class: 'text-center',
			},
			{
				label: 'Ações',
				field: 'actions',
				class: 'text-center',
			},
		],
		crawlerExecutionsData: {
			content: [],
			totalElements: 0,
			currentPage: 0,
			totalPages: 0,
			size: 20,
		},
		crawlerExecutionsFilters: {},
		crawlerExecutionsPage: 1,
		crawlerExecutionsPerPage: 20,
		crawlerErrorModalOpen: false,
		crawlerErrorModalData: null,
		crawlerErrorModalTitle: '',
    }
  },
  methods: {
	perPageChange(data) {
		this.perPage = data.perPage;
		this.currentPage = data.page;
	},
	rejectMotivationText(motivation) {
		if(!motivation) {
			return '';
		}
		let rejectMotivation = this.rejectMotivation.find((item) => item.value === motivation)
		if (rejectMotivation) {
			return rejectMotivation.label;
		}
		return motivation;
	},
	formatSendedBy(sendedBy) {
		if (sendedBy === 'SOWHUB_CRAWLER') {
			return 'Crawler de Tracking';
		}
		return sendedBy;
	},
	async refreshProcessOpen() {
		await this.getProcesses(undefined, false);
		if (this.selectedProcess && this.selectedProcessData?.gescomexId) {
			await this.getProcessData(this.selectedProcess, this.selectedProcessData?.gescomexId)
		}
	},
	clearCrawlerManualBlock() {
		if (this.crawlerManualRetryTimer) {
			clearTimeout(this.crawlerManualRetryTimer);
			this.crawlerManualRetryTimer = null;
		}
		this.crawlerManualRetryAt = null;
	},
	startCrawlerManualBlock(retryAllowedAt) {
		this.clearCrawlerManualBlock();

		if (!retryAllowedAt) {
			return;
		}

		// retryAllowedAt é um LocalDateTime sem offset. Limitar a espera ao teto da janela
		// (10 min) evita que uma diferença de fuso entre servidor e browser bloqueie o botão
		// por muito mais tempo do que o rate-limit real.
		const windowInMs = 10 * 60 * 1000;
		const remaining = Math.min(Math.max(moment(retryAllowedAt).diff(moment()), 0), windowInMs);

		if (remaining === 0) {
			return;
		}

		this.crawlerManualRetryAt = retryAllowedAt;
		this.crawlerManualRetryTimer = setTimeout(() => {
			this.crawlerManualRetryAt = null;
			this.crawlerManualRetryTimer = null;
		}, remaining);
	},
	async enqueueManualCrawlerQuery() {
		const processId = this.selectedProcessData?.gescomexId;

		if (!processId) {
			return;
		}

		const result = await Swal.fire({
			title: 'Consulta manual ao Sowhub Crawler',
			text: 'Você tem certeza que deseja consultar os dados desse processo manualmente?',
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Sim, consultar!',
			cancelButtonText: 'Não',
		});

		if (!result.value) {
			return;
		}

		this.$store.commit('setLoading', {
			show: true,
			label: 'Consulta manual ao Sowhub Crawler',
			description: 'Aguarde, estamos enviando a consulta para a fila do Crawler!',
		});

		try {
			const response = await Axios.post(
				`${config.env.API_DEFAULT.host}/sowhub-crawler/schedule/inbound/manual/${processId}`
			);

			const title = response?.data?.title ?? 'Consulta manual ao Sowhub Crawler';
			const message = response?.data?.message ?? 'Consulta manual enviada ao Crawler.';
			const data = response?.data?.data ?? {};

			if (data.throttled === true) {
				this.startCrawlerManualBlock(data.retryAllowedAt);

				Swal.fire({
					title,
					text: message,
					type: 'warning',
				});

				return;
			}

			this.startCrawlerManualBlock(data.retryAllowedAt);

			Swal.fire({
				title,
				text: message,
				type: 'success',
			});
		} catch (e) {
			const errorData = e?.response?.data;
			const message = errorData?.message ?? 'Erro inesperado ao enviar a consulta manual ao Crawler!';
			const detail = typeof errorData?.data === 'string' ? errorData.data : null;

			Swal.fire({
				title: errorData?.title ?? 'Consulta manual ao Sowhub Crawler',
				text: detail ? `${message} (${detail})` : message,
				type: 'error',
			});
		} finally {
			this.$store.commit('setLoading', { show: false });
		}
	},
    openJustification(data) {
      this.justificationModalOpen = true;
      this.justificationData = data;
    },
    closeJustification() {
      this.justificationModalOpen = false;
      this.justificationData = null;
    },
    async getProcesses(filters, clearSelectProcess = false) {

		if (filters === undefined) {
			filters = Object.keys(this.stateFilters).length > 0 ? this.stateFilters : undefined;
		}

		this.$store.commit('setLoading', {
			show: true,
			label: `Buscando processos`,
			description: 'Aguarde, estamos buscando os processos que receberam dados!'
		});

		try {
			const params = {};

			if (filters.customer !== null && filters.customer !== undefined) {
				params.customerId = filters.customer.id;
			}

			const response = await Axios.get(`${config.env.API_DEFAULT.host}/forwarders-integrations/processes/processes-with-data`, {
				params: filters
			});

			this.stateFilters = filters;
			this.processes = response.data.data;

			this.sortProcesses();

			if (clearSelectProcess) {
				this.selectedProcess = null;
				this.selectedProcessId = null;
				this.selectedProcessData = {};
				this.processData = [];
				if (!response.data || !response.data.data || !Array.isArray(response.data.data) || response.data.data.length === 0) {
					this.processes = [];
				}
			}

			this.$store.commit('setLoading', {
				show: false,
			});
		} catch (e) {
			this.$store.commit('setLoading', {
				show: false,
			});
		}
    },
    async getProcessDataList() {
      this.$store.commit('setLoading', {
        show: true,
        label: `Buscando dados enviados`,
        description: 'Aguarde, estamos buscando a listagem geral de dados recebidos!'
      });

      try {
        const response = await Axios.get(`${config.env.API_DEFAULT.host}/forwarders-integrations/process-data`);

        this.processData = response.data.data;

        this.$store.commit('setLoading', {
          show: false,
        });
      } catch (e) {

        this.$store.commit('setLoading', {
          show: false,
        });
      }
    },
    async checkContainers(data, processId) {
      this.$store.commit('setLoading', {
        show: true,
        label: `Buscando os containers do processo`,
        description: 'Aguarde, estamos buscando os containers cadastrados!'
      });

      this.containersSended = JSON.parse(data.SENDED.value);
      this.openModalCheckContainers = true;
      this.containersDataSelected = data;

      try {
        const response = await Axios.get(`${config.env.API_DEFAULT.host}/process/import/${processId}/containers/find-by-process-id`);

        this.containersCurrent = response.data.data;

        this.$store.commit('setLoading', {
          show: false,
        });
      } catch (e) {
        this.$store.commit('setLoading', {
          show: false,
        });
      }
    },
    formatDateFunction(date) {
      return moment(date).format('DD/MM/YYYY');
    },
	formatDateTimeFunction(date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss');
    },
    calculateContainerDeadline(date, days) {
      return moment(date)
        .add(days, 'days')
        .format('DD/MM/YYYY');
    },
    async getProcessData(identification, processId) {
      this.selectedProcess = identification;
      this.clearCrawlerManualBlock();
      this.$store.commit('setLoading', {
        show: true,
        label: `Buscando dados do processo`,
        description: 'Aguarde, estamos buscando os dados enviados para o processo!'
      });

	  const processData = this.filteredProcesses.find(process => process.gescomexId === processId);

      this.selectedProcessData = {
		forwarderName: processData.forwarderName,
		urgent: processData.urgent ?? false,
		typeOfBoarding: processData.typeOfBoarding ?? '-',
		wayOfTransport: processData.wayOfTransport ?? '-',
		gescomexId: processData.gescomexId
	  };

      try {
        const response = await Axios.get(`${config.env.API_DEFAULT.host}/forwarders-integrations/process-data/${identification}?processId=${processId}`);

        this.processData = response.data.data.sort((data1, data2) => {
          	return new Date(data2.SENDED.sendedAt) - new Date(data1.SENDED.sendedAt);
        });

        await this.getProcesses(this.stateFilters);

		this.scrollToSection(`process-anchor-${processId}`);

        this.$store.commit('setLoading', {
          show: false,
        });
      } catch (e) {
		this.processData = [];
		this.selectedProcess = null;
		this.selectedProcessId = null;
		this.selectedProcessData = {};
        this.$store.commit('setLoading', {
          show: false,
        });

		Swal.fire({
			title: "Dados de integração do Processo",
			html: `<p>Erro inesperado ao tentar buscar os dados do Processo!</p>`,
			type: "error",
		});
      }
    },
	scrollToSection(sectionId) {
      this.$nextTick(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
          });
        }
      });
    },
    async approveProcessData(data) {
      this.selectedProcessId = data.PROCESS_ID;
      this.fieldToApprove = data.SENDED.field;

      Swal.fire({
        title: 'Aprovação de dados',
        html: `<p>Você tem certeza que deseja aprovar esta informação?</p> <p>Essa observação não poderá ser alterada após ser salva.</p>`,
        type: 'warning',
        input: "textarea",
        inputPlaceholder: "Observações da aprovação: ",
        showConfirmButton: true,
        confirmButtonText: 'Aprovar',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
      }).then(async (result) => {
        if (!result.dismiss) {
          this.$store.commit('setLoading', {
            show: true,
            label: `Aprovação de dados`,
            description: 'Aguarde, estamos atualizando a informação no processo!'
          });
          try {
            const response = await Axios.post(`${config.env.API_DEFAULT.host}/forwarders-integrations/process-data/approve/${data.PROCESS_ID}`, {
              field: data.SENDED.field,
              value: data.SENDED.value,
              destinationPortValue: data.SENDED.destinationPortCodeIso,
              processDataId: data.SENDED.id,
              sendedBy: data.SENDED.sendedBy,
              sendedByEmail: data.SENDED.sendedByEmail,
              sendedAt: data.SENDED.sendedAt,
              justification: result.value
            });

            this.$store.commit('setLoading', {
              show: false,
            });

            if (data.SENDED.field === 'CONTAINERS') {
              document.getElementById('closeModalContainers').click();
            }

            Swal.fire({
              title: "Aprovação de dados",
              html: `<p>Dado aprovado com sucesso!</p>`,
              type: "success",
            });

            await this.getProcessData(ProcessService.getTypeOfProcessReference(response.data.data), data.PROCESS_ID);

            let field = data.SENDED.field;

            // Após a aprovação, abrir o modal de histórico
            if (
              field === 'ETA'
              || field === 'ETD'
              || field === 'BOARDING'
              || field === 'ARRIVAL'
              || field === 'READINESS'
              || field === 'ESTIMATE_READINESS'
			  || field === 'CARGO_COLLECT'
			  || field === 'ESTIMATED_CARGO_COLLECT'
            ) {
              this.modalHistoryOpen = true;

              this.formHistory.datesETA = response.data.data.datesETA;
              this.formHistory.datesETD = response.data.data.datesETD;
              this.formHistory.initialDatesETD = response.data.data.initialDatesETD;
              this.formHistory.datesEstimatedCustomerDeliverDate = response.data.data.datesEstimatedCustomerDeliverDate;
              this.formHistory.processId = response.data.data.id;
              this.formHistory.status = response.data.data.status;
            }

          } catch (e) {

            this.$store.commit('setLoading', {
              show: false,
            });

            Swal.fire({
              title: "Aprovação de dados",
              html: `<p>Houve um erro inesperado ao aprovar informação!</p>`,
              type: "error",
            });
          }
        }
      })
    },
    async closeHistoryModal() {
      this.modalHistoryOpen = false;

      this.clearHistoryForm();

      const dateFields = {
        "ETD": "datesETD",
        "ETA": "datesETA",
        "ARRIVAL": "datesArrivalDate",
        "BOARDING": "datesDepartureDate",
        "READINESS": "datesGoodsReadinesDate",
		"CARGO_COLLECT": "datesCargoCollectDate",
        "ESTIMATE_READINESS": "datesEstimatedGoodsReadinesDate",
		"ESTIMATED_CARGO_COLLECT": "datesEstimatedCargoCollectDate"
      }

      let field = dateFields[this.fieldToApprove];

      await this.checkEvents(this.selectedProcessId, field);
    },
    async checkEvents(processId, field) {
      const checkEventResponse = await Axios.get(config.env.API_DEFAULT.host + "/process/import/checkEvent/" + processId + "/" + field + "/check/true");

      if (checkEventResponse.status === 200) {

        if (checkEventResponse.data.listOfMessages.length > 0) {
          // Verifica se o usuário quer enviar evento
          Swal.fire({
            title: 'Eventos do Processo',
            html: `<p>Os eventos abaixo foram encontrados, você deseja dispará-los?</p>` +
              `<div class="card"><div class="card-body">${checkEventResponse.data.listOfMessages[0]}</div></div>`,
            type: 'warning',
            showConfirmButton: true,
            confirmButtonText: 'Enviar',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
          }).then(async (result) => {
            if (result.value) {
              this.$store.commit("setLoading", {
                show: true,
                label: "Eventos de Processo",
                description: "Enviando o seguinte evento: " + checkEventResponse.data.listOfMessages[0]
              });

              // Faz o disparo do evento
              try {
                const responseSendEvent = await Axios.get(config.env.API_DEFAULT.host + "/process/import/checkEvent/" + processId + "/" + field + "/check/false");

                if (responseSendEvent.data.data[0] !== undefined && responseSendEvent.data.data[0] !== null) {
                  if (
                    responseSendEvent.data.data[0].actions !== undefined
                    && responseSendEvent.data.data[0].actions !== null
                    && responseSendEvent.data.data[0].actions.CHANGE_STEP !== undefined
                    && responseSendEvent.data.data[0].actions.CHANGE_STEP !== null
                  ) {
                    const step = responseSendEvent.data.data[0].actions.CHANGE_STEP;

                    const changeStepResponse = await Axios.put(
                      config.env.API_DEFAULT.host + '/newImportProcess/' + processId + '/step/' + step.id,
                      {},
                      { headers: { 'Content-Type': 'application/json' } }
                    );

                    Swal.fire({
                      type: "success",
                      title: "Eventos do Processo " + changeStepResponse.data.data.identification,
                      html: `O Follow UP foi enviado com sucesso e a etapa do processo foi alterada para <strong>${step.description}</strong>`,
                      showConfirmButton: true,
                      timer: 5000,
                    });
                  } else {
                    Swal.fire({
                      type: "success",
                      title: "Eventos do Processo",
                      html: responseSendEvent.data.data[0].message,
                      showConfirmButton: true,
                      timer: 5000,
                    });
                  }
                }

                this.$store.commit("setLoading", {
                  show: false,
                });
              } catch (e) {
                Swal.fire({
                  type: "error",
                  title: "Houve um erro inesperado ao enviar o Follow UP: " + e.response.data.message,
                  timer: 5000,
                });
              }
            }

            this.$store.commit("setLoading", {
              show: false,
            });
          });
        }
      }
    },
    async rejectProcessData(data) {
      Swal.fire({
        title: 'Rejeição de dados',
		html: `
          <p>Você tem certeza que deseja contestar esta informação?</p>
          <p>O motivo e justificativa não poderá ser alterada após ser salva.</p>
          <div class="input-control text-left mt-3 pr-4 pl-4 flex fd-c">
			<label for="rejectReason" class="form-control-label label-form" >Motivo <span class="text-danger">*</span></label>
            <select id="rejectReason" class="swal2-select modify" required>
				<option value=""></option>
				<option value="INCORRECT_OUTDATED" >Valores incorretos ou desatualizados</option>
				<option value="OTHER_INTERNAL_MOTIVATION" >Outros motivos internos</option>	
            </select>
			<span class="text-danger alert-error-danger" id="rejectReasonError">
				Motivo é obrigatório
			</span>
          </div>
          <div class="input-control text-left mt-3 pr-4 pl-4 flex fd-c">
            <label for="justification" class="form-control-label label-form">Justificativa</label>
            <textarea id="justification" class="swal2-textarea modify" placeholder="Informe uma justificativa" style="min-height: 100px;"></textarea>
          </div>
        `,
        type: 'warning',
        showConfirmButton: true,
        confirmButtonText: 'Contestar',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        focusConfirm: false,
        preConfirm: () => {
          const reason = document.getElementById('rejectReason').value;
          const justification = document.getElementById('justification').value;

		  if (!reason) {
            document.getElementById('rejectReason').classList.add('input-danger');
			document.getElementById('rejectReasonError').style.display = 'block';
			return false;
          }

          return { reason, justification };
        }
      }).then(async (result) => {
        if (result.dismiss !== 'cancel') {
          this.$store.commit('setLoading', {
            show: true,
            label: `Contestação de Dados`,
            description: 'Aguarde, estemos executando a contestação!'
          });

          try {
            const response = await Axios.post(`${config.env.API_DEFAULT.host}/forwarders-integrations/process-data/reject/${data.PROCESS_ID}`, {
              field: data.SENDED.field,
              value: data.SENDED.value,
              processDataId: data.SENDED.id,
              sendedBy: data.SENDED.sendedBy,
              sendedByEmail: data.SENDED.sendedByEmail,
              sendedAt: data.SENDED.sendedAt,
              justification: result.value.justification,
              approveRejectMotivation: result.value.reason
            });

            this.$store.commit('setLoading', {
              show: false,
            });

            Swal.fire({
              title: "Contestação de Dados",
              html: `<p>Dado contestado com sucesso!</p>`,
              type: "success",
            });

			let dataIdentification = response.data.data.identification
			if (/^[0-9]+$/.test(dataIdentification)) {
				dataIdentification = ProcessService.getTypeOfProcessReference(response.data.data);
			} 

            await this.getProcessData(dataIdentification, data.PROCESS_ID);
			
          } catch (e) {

            this.$store.commit('setLoading', {
              show: false,
            });

            Swal.fire({
              title: "Contestação de Dados",
              html: `<p>Houve um erro inesperado ao contestar informação!</p>`,
              type: "error",
            });
          }
        }
      })
    },
    getDataValue(data) {
      if (
        data.field === 'ETD'
        || data.field === 'ETA'
        || data.field === 'ARRIVAL'
        || data.field === 'READINESS'
        || data.field === 'ESTIMATE_READINESS'
        || data.field === 'BOARDING'
        || data.field === 'MOORING'
        || data.field === 'SISCARGA'
        || data.field === 'MAPA'
		|| data.field === 'CARGO_COLLECT'
		|| data.field === 'ESTIMATED_CARGO_COLLECT'
      ) {
        return moment(data.value).format('DD/MM/yyyy');
        // return data.value;
      }

      if (data.field === 'CONTAINERS') {
        return JSON.parse(data.value).length;
      }

      return data.value;
    },
    getCurrentDataValue(data) {
      if (
        data.SENDED.field === 'ETD'
        || data.SENDED.field === 'ETA'
        || data.SENDED.field === 'ARRIVAL'
        || data.SENDED.field === 'READINESS'
        || data.SENDED.field === 'ESTIMATE_READINESS'
        || data.SENDED.field === 'BOARDING'
        || data.SENDED.field === 'MOORING'
        || data.SENDED.field === 'SISCARGA'
        || data.SENDED.field === 'MAPA'
		|| data.field === 'CARGO_COLLECT'
		|| data.field === 'ESTIMATED_CARGO_COLLECT'
      ) {
        return moment(data.CURRENT).format('DD/MM/yyyy');
      }

      if (data.SENDED.field === 'DESTINATION_PORT') {
        return data.CURRENT.alias + ' - ' + data.CURRENT.codeIso;
      }

      if (data.SENDED.field === 'CONTAINERS') {
        return data.CURRENT;
      }

      return data.CURRENT;
    },
    async submitOtherDatesAndHistoryForm() {
      this.$store.commit('setLoading', {
        show: true,
        label: `Salvando dados do Processo`,
        description: 'Aguarde, estamos salvando as informações de data e histórico!'
      });

      try {
        const data = {
          processId: this.formHistory.processId,
          datesETA: this.formHistory.datesETA !== null && this.formHistory.datesETA !== ''
            ? moment(this.formHistory.datesETA).format('Y-MM-DD') + 'T00:00:00'
            : null,
          datesETD: this.formHistory.datesETD !== null && this.formHistory.datesETD !== ''
            ? moment(this.formHistory.datesETD).format('Y-MM-DD') + 'T00:00:00'
            : null,
          initialDatesETD: this.formHistory.initialDatesETD !== null && this.formHistory.initialDatesETD !== ''
            ? moment(this.formHistory.initialDatesETD).format('Y-MM-DD') + 'T00:00:00'
            : null,
          datesEstimatedCustomerDeliverDate: this.formHistory.datesEstimatedCustomerDeliverDate !== null && this.formHistory.datesEstimatedCustomerDeliverDate !== ''
            ? moment(this.formHistory.datesEstimatedCustomerDeliverDate).format('Y-MM-DD') + 'T00:00:00'
            : null,
          sendHistory: this.formHistory.sendHistory,
          historyPriority: this.formHistory.historyPriority,
          historyContent: this.formHistory.historyContent,
          isVisibleToCustomer: this.formHistory.isVisibleToCustomer,
          status: this.formHistory.status
        }

        const response = await Axios.post(`${config.env.API_DEFAULT.host}/forwarders-integrations/other-dates-and-history`, data);

        this.$store.commit('setLoading', {
          show: false,
        });

        if (
          data.sendHistory
          && (data.historyContent !== null && data.historyContent !== '')
          && data.isVisibleToCustomer
        ) {
          Swal.fire({
            title: "Enviar Follow UP",
            text: "Você acabou de adicionar um Histórico visível ao cliente, você deseja enviar o Follow-UP agora?",
            type: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim, enviar!",
            cancelButtonText: "Não"
          }).then(async (result) => {
            if (result.value) {
              this.$store.dispatch("ProcessStore/sendFollowUP", {
                id: data.processId,
                identification: this.selectedProcess
              }).then(async () => {
                await this.closeHistoryModal();
              });
            } else{
              Swal.fire({
                title: 'Dados do Processo',
                type: 'success',
                text: 'Dados salvos com sucesso!'
              });
              this.modalHistoryOpen = false;
              this.clearHistoryForm();
            }

          });
        } else {
          Swal.fire({
            title: 'Dados do Processo',
            type: 'success',
            text: 'Dados salvos com sucesso!'
          });

          await this.closeHistoryModal();
        }

      } catch (e) {
        this.$store.commit('setLoading', {
          show: false,
        });
      }
    },
    clearHistoryForm() {
      this.formHistory.processId = null;
      this.formHistory.datesETA = null;
      this.formHistory.datesETD = null;
      this.formHistory.initialDatesETD = null;
      this.formHistory.datesEstimatedCustomerDeliverDate = null;

      this.formHistory.sendHistory = false;
      this.formHistory.historyPriority = null;
      this.formHistory.historyContent = null;
      this.formHistory.isVisibleToCustomer = false;
    },
    sortProcesses() {
      this.$store.commit('setLoading', {
        show: true,
      });

      if (this.sortFilter === 'RECENT') {
        this.processes = this.processes.sort((a, b) => new Date(b.lastDataSendedAt) - new Date(a.lastDataSendedAt));
      }

      if (this.sortFilter === 'UNREADED') {
        this.processes = this.processes.sort((a, b) => a.viewed - b.viewed);
      }

      if (this.sortFilter === 'READED') {
        this.processes = this.processes.sort((a, b) => b.viewed - a.viewed);
      }

      if (this.sortFilter === 'ITENS_NOT_READED') {
        this.processes = this.processes.sort((a, b) => b.unviewedDataCount - a.unviewedDataCount);
      }

	  if (this.sortFilter === 'PROCESS_IS_URGENT') {
        this.processes = this.processes.sort((a, b) => {
			const urgentA = Boolean(a.urgent);
			const urgentB = Boolean(b.urgent);
			return urgentB - urgentA;
		});
      }

      this.$store.commit('setLoading', {
        show: false,
      });
    },
	async getProcessesWithErrors(filters = {}) {
		this.processesWithErrors = [];
		// this.$store.commit('setLoading', { show: true });
		// const response = await Axios.get(`${config.env.API_DEFAULT.host}/integrations/searates/failed-requests`, { params: filters });
		// if (response?.data?.data) {
		// 	this.processesWithErrors = Object.entries(response.data.data).map(([processIdentification, trackingData]) => ({
		// 		processIdentification,
		// 		trackingData
		// 	}));
		// }
		this.$store.commit('setLoading', { show: false });
	},
	onCrawlerExecutionsFilter(filters) {
		this.crawlerExecutionsFilters = filters;
		this.getCrawlerExecutions(1, this.crawlerExecutionsPerPage, filters);
	},
	onCrawlerExecutionsPageChange({ page, perPage }) {
		this.getCrawlerExecutions(page, perPage);
	},
	onCrawlerExecutionsPerPageChange({ page, perPage }) {
		this.getCrawlerExecutions(page, perPage);
	},
	async getCrawlerExecutions(page = 1, perPage = null, filters = undefined) {
		const size = perPage ?? this.crawlerExecutionsPerPage;

		if (filters !== undefined) {
			this.crawlerExecutionsFilters = filters;
		}

		this.$store.commit('setLoading', {
			show: true,
			label: 'Buscando execuções',
			description: 'Aguarde, estamos buscando as execuções bem-sucedidas do Crawler de Tracking!',
		});

		try {
			const params = {
				page: page - 1,
				size,
			};

			const appliedFilters = this.crawlerExecutionsFilters || {};

			if (appliedFilters.customerId) {
				params.customerId = appliedFilters.customerId;
			}
			if (appliedFilters.teamId) {
				params.teamId = appliedFilters.teamId;
			}
			if (appliedFilters.customsTeamId) {
				params.customsTeamId = appliedFilters.customsTeamId;
			}
			if (appliedFilters.identification) {
				const numeric = String(appliedFilters.identification).replace(/\D/g, '');
				if (numeric) {
					params.identification = numeric;
				}
			}
			if (appliedFilters.startDate) {
				params.startDate = moment(appliedFilters.startDate).format('YYYY-MM-DD');
			}
			if (appliedFilters.endDate) {
				params.endDate = moment(appliedFilters.endDate).format('YYYY-MM-DD');
			}

			const response = await Axios.get(
				`${config.env.API_DEFAULT.host}/sowhub-crawler/queue-items/executions`,
				{ params }
			);

			if (response?.data?.data) {
				this.crawlerExecutionsData = response.data.data;
				this.crawlerExecutionsPage = (response.data.data.currentPage ?? 0) + 1;
				this.crawlerExecutionsPerPage = response.data.data.size ?? size;
			} else {
				this.crawlerExecutionsData = {
					content: [],
					totalElements: 0,
					currentPage: 0,
					totalPages: 0,
					size,
				};
				this.crawlerExecutionsPage = 1;
			}
		} catch (e) {
			Swal.fire({
				title: 'Execuções do Crawler de Tracking',
				text: 'Erro ao listar execuções bem-sucedidas!',
				type: 'error',
			});
			this.crawlerExecutionsData = {
				content: [],
				totalElements: 0,
				currentPage: 0,
				totalPages: 0,
				size,
			};
			this.crawlerExecutionsPage = 1;
		} finally {
			this.$store.commit('setLoading', { show: false });
		}
	},
	onCrawlerErrorsFilter(filters) {
		this.crawlerErrorsFilters = filters;
		this.getCrawlerExecutionErrors(1, this.crawlerErrorsPerPage, filters);
	},
	onCrawlerErrorsPageChange({ page, perPage }) {
		this.getCrawlerExecutionErrors(page, perPage);
	},
	onCrawlerErrorsPerPageChange({ page, perPage }) {
		this.getCrawlerExecutionErrors(page, perPage);
	},
	async getCrawlerExecutionErrors(page = 1, perPage = null, filters = undefined) {
		const size = perPage ?? this.crawlerErrorsPerPage;

		if (filters !== undefined) {
			this.crawlerErrorsFilters = filters;
		}

		this.$store.commit('setLoading', {
			show: true,
			label: 'Buscando erros',
			description: 'Aguarde, estamos buscando os erros de execução do Crawler de Tracking!',
		});

		try {
			const params = {
				page: page - 1,
				size,
			};

			const appliedFilters = this.crawlerErrorsFilters || {};

			if (appliedFilters.customerId) {
				params.customerId = appliedFilters.customerId;
			}
			if (appliedFilters.teamId) {
				params.teamId = appliedFilters.teamId;
			}
			if (appliedFilters.customsTeamId) {
				params.customsTeamId = appliedFilters.customsTeamId;
			}
			if (appliedFilters.identification) {
				const numeric = String(appliedFilters.identification).replace(/\D/g, '');
				if (numeric) {
					params.identification = numeric;
				}
			}
			if (appliedFilters.startDate) {
				params.startDate = moment(appliedFilters.startDate).format('YYYY-MM-DD');
			}
			if (appliedFilters.endDate) {
				params.endDate = moment(appliedFilters.endDate).format('YYYY-MM-DD');
			}

			const response = await Axios.get(
				`${config.env.API_DEFAULT.host}/sowhub-crawler/queue-items/execution-errors`,
				{ params }
			);

			if (response?.data?.data) {
				this.crawlerErrorsData = response.data.data;
				this.crawlerErrorsPage = (response.data.data.currentPage ?? 0) + 1;
				this.crawlerErrorsPerPage = response.data.data.size ?? size;
			} else {
				this.crawlerErrorsData = {
					content: [],
					totalElements: 0,
					currentPage: 0,
					totalPages: 0,
					size,
				};
				this.crawlerErrorsPage = 1;
			}
		} catch (e) {
			Swal.fire({
				title: 'Erros do Crawler de Tracking',
				text: 'Erro ao listar erros de execução!',
				type: 'error',
			});
			this.crawlerErrorsData = {
				content: [],
				totalElements: 0,
				currentPage: 0,
				totalPages: 0,
				size,
			};
			this.crawlerErrorsPage = 1;
		} finally {
			this.$store.commit('setLoading', { show: false });
		}
	},
	openCrawlerErrorModal(item) {
		const prefix = this.action === 'crawler-executions' ? 'Execução' : 'Erro';
		this.crawlerErrorModalTitle = `${prefix} - ${item.formattedReference || item.processIdentification || item.id}`;
		this.crawlerErrorModalData = item;
		this.crawlerErrorModalOpen = true;
	},
	closeCrawlerErrorModal() {
		this.crawlerErrorModalOpen = false;
		this.crawlerErrorModalData = null;
	},
	formatJsonPayload(value) {
		if (!value) {
			return '-';
		}
		try {
			return JSON.stringify(JSON.parse(value), null, 2);
		} catch (e) {
			return value;
		}
	},
	getCrawlerRuleDescription(rule) {
		if (!rule) {
			return null;
		}
		return SOWHUB_CRAWLER_RULE_DESCRIPTIONS[rule] || null;
	},
	getCrawlerMessageStatusClass(status) {
		return status.toLowerCase() === 'error' ? 'badge-danger' : 'badge-warning';
	},
	copyCrawlerPayloadToClipboard(value) {
		const text = this.formatJsonPayload(value);
		const storage = document.createElement('textarea');
		storage.value = text;
		document.body.appendChild(storage);
		storage.select();
		storage.setSelectionRange(0, 99999);
		document.execCommand('copy');
		document.body.removeChild(storage);
		this.$toasted.success('Copiado!', { duration: 600 });
	},
	openErrorsModal(item) {
		this.errorsModalTitle = `Processo - ${item.processIdentification}`;
		this.errorsModalData = [];
		this.errorsModalOpen = true;
		this.errorsModalData = item;
	},
	closeErrorsModal() {
		this.errorsModalOpen = false;
		this.errorsModalData = [];
	},
  },
  watch: {
	'$route.params.action'(action) {
		this.action = action ?? null;
		if (action === 'crawler-errors') {
			this.getCrawlerExecutionErrors();
		}
		if (action === 'crawler-executions') {
			this.getCrawlerExecutions();
		}
	},
  },
  filters: {
    formatDate: (date) => {
      return moment(date).locale('pt-br').format('DD/MM/YY [às] HH:mm');
    },
    formatDateOnly: (date) => {
      return moment(date).locale('pt-br').format('DD/MM/YY');
    },
    formatField: (field) => {
      if (field === 'BL_AWB') {
        return 'BL/AWB';
      }

      if (field === 'BL_AWB_MASTER') {
        return 'Master';
      }

      if (field === 'SHIP' || field === 'VEHICLE') {
        return 'Veículo de Transbordo (Atual)';
      }

      if (field === 'VEHICLE_TRANSHIPMENT') {
        return 'Navio de Embarque';
      }

      if (field === 'DESTINATION_PORT') {
        return 'Porto de destino';
      }

      if (field === 'TRANSIT_TIME') {
        return 'Transit time';
      }

      if (field === 'ESTIMATE_READINESS') {
        return 'Prontidão (Prevista)'
      }

      if (field === 'READINESS') {
        return 'Prontidão';
      }

      if (field === 'BOARDING') {
        return 'Embarque';
      }

      if (field === 'ARRIVAL') {
        return 'Chegada';
      }

      if (field === 'MOORING') {
        return 'Atracação';
      }

	  if (field === 'CARGO_COLLECT') {
		  return 'Coleta';
	  }

	  if (field === 'ESTIMATED_CARGO_COLLECT') {
		return 'Coleta Prevista';
	  }

      return field;
    },
	formatMotivation(field) {
		try {
			const motivation = JSON.parse(field);

			let searatesErrorMessages = {
                'WRONG_PARAMETERS': {
                    code: 'WRONG_PARAMETERS',
                    message: 'Parâmetros incorretos',
                    description: 'Requisição faltando parâmetros obrigatórios (Avise o suporte)'
                },
                'WRONG_NUMBER': {
                    code: 'WRONG_NUMBER',
                    message: 'Número inválido',
                    description: 'Informações de BL ou Nº de Booking são inválidas'
                },
                'WRONG_SEALINE': {
                    code: 'WRONG_SEALINE',
                    message: 'Armador inválido',
                    description: 'Código alpha do Armador (SCAC) especificado é inválido'
                },
                'WRONG_TYPE': {
                    code: 'WRONG_TYPE',
                    message: 'Tipo de documento inválido',
                    description: 'O tipo de documento especificado é inválido'
                },
                'SEALINE_NOT_SUPPORTED': {
                    code: 'SEALINE_NOT_SUPPORTED',
                    message: 'Armador não suportado',
                    description: 'Não há suporte para este Armador'
                },
                'SEALINE_NOT_SUPPORT_SHIPMENT_TYPE': {
                    code: 'SEALINE_NOT_SUPPORT_SHIPMENT_TYPE',
                    message: 'Tipo de frete não suportado',
                    description: 'O Armador não suporta o tipo de frete especificado'
                },
                'SEALINE_TEMPORARY_DISABLED': {
                    code: 'SEALINE_TEMPORARY_DISABLED',
                    message: 'Armador temporariamente indisponível',
                    description: 'O Armador solicitado está temporariamente desativada'
                },
                'SEALINE_UNDER_MAINTENANCE': {
                    code: 'SEALINE_UNDER_MAINTENANCE',
                    message: 'Manutenção em andamento',
                    description: 'O suporte para a Armador solicitado está em manutenção'
                },
                'SEALINE_NO_RESPONSE': {
                    code: 'SEALINE_NO_RESPONSE',
                    message: 'Sem resposta da transportadora',
                    description: 'Ocorreu um erro ao processar a requisição. A transportadora não está respondendo'
                },
                'AUTO_CANT_DETECT_SEALINE': {
                    code: 'AUTO_CANT_DETECT_SEALINE',
                    message: 'Não foi possível identificar o Armador',
                    description: 'Não foi possível determinar automaticamente o Armador deste processo'
                },
                'AUTO_CANT_DETECT_TYPE': {
                    code: 'AUTO_CANT_DETECT_TYPE',
                    message: 'Tipo não identificado',
                    description: 'Não foi possível determinar automaticamente o tipo'
                },
                'AUTO_CANT_FIND_INFO': {
                    code: 'AUTO_CANT_FIND_INFO',
                    message: 'Informações não encontradas',
                    description: 'Não foi possível recuperar automaticamente os dados solicitados'
                },
                'API_KEY_WRONG': {
                    code: 'API_KEY_WRONG',
                    message: 'Chave de API inválida',
                    description: 'A chave de API fornecida é inválida (Avise o suporte)'
                },
                'API_KEY_ACCESS_DENIED': {
                    code: 'API_KEY_ACCESS_DENIED',
                    message: 'Acesso negado',
                    description: 'Esta chave de API não tem acesso ao produto solicitado (Avise o suporte)'
                },
                'API_KEY_EXPIRED': {
                    code: 'API_KEY_EXPIRED',
                    message: 'Chave de API expirada',
                    description: 'Esta chave de API expirou (Avise o suporte)'
                },
                'API_KEY_LIMIT_REACHED': {
                    code: 'API_KEY_LIMIT_REACHED',
                    message: 'Limite de requisições atingido',
                    description: 'Esta chave de API excedeu o limite de requisições (Avise o suporte)'
                },
                'API_KEY_RATE_LIMIT': {
                    code: 'API_KEY_RATE_LIMIT',
                    message: 'Limite de frequência excedido',
                    description: 'Esta chave de API excedeu o limite de frequência de requisições permitido (Avise o suporte)'
                },
                'UNEXPECTED_ERROR': {
                    code: 'UNEXPECTED_ERROR',
                    message: 'Erro inesperado',
                    description: 'Ocorreu um erro inesperado (Avise o suporte)'
                }
            }
			
			if (searatesErrorMessages[motivation.message]) {
				return searatesErrorMessages[motivation.message].description;
			}

			return motivation?.message || '-';
			
		} catch (e) {
			console.error('Erro ao formatar motivação:', e);
			return field ? field.replace(/\\n/g, ' ') : '-';
		}
	}
  },
	computed: {
		filteredProcesses() {
			const regExp = new RegExp(this.processSearch, 'gi');

			let processes = this.processes;

			if (this.processSearch !== '') {
			processes = this.processes.filter(item => regExp.test(item.identification) || regExp.test(item.customerName));
			}

			return processes;
		},
		initialSortConfig() {
			const initialSortColumn = this.tableColumns.find(col => col.initialSort);
			if (initialSortColumn) {
				return {
					field: initialSortColumn.field,
					direction: initialSortColumn.initialSortDirection || 'asc'
				};
			}
			return { field: null, direction: 'asc' };
		},	
		LabelFilter() {
			if (this.sortFilter === 'RECENT') {
				return 'Ordenado por Recentes';
			} else if (this.sortFilter === 'UNREADED') {
				return 'Ordenado por Processos não Visualizados';
			} else if (this.sortFilter === 'READED') {
				return 'Ordenado por Processos Visualizados';
			} else if (this.sortFilter === 'ITENS_NOT_READED') {
				return 'Ordenado por Itens (dados) não visualizados';
			} else if (this.sortFilter === 'PROCESS_IS_URGENT') {
				return 'Ordenado por Processo Urgente';
			}

			return 'Filtros';
		},
		crawlerManualBlocked() {
			return Boolean(this.crawlerManualRetryAt);
		},
		crawlerManualTooltip() {
			if (this.crawlerManualRetryAt) {
				return `Consulta manual já realizada. Nova consulta liberada às ${moment(this.crawlerManualRetryAt).format('HH:mm:ss')}.`;
			}

			return 'Consultar tracking manualmente no Crawler';
		}
	},
	beforeDestroy() {
		this.clearCrawlerManualBlock();
	},
	async created() {
		if (this.$route.params?.action === 'logs') {
			await this.getProcessesWithErrors();
		}
		if (this.$route.params?.action === 'crawler-errors') {
			await this.getCrawlerExecutionErrors();
		}
		if (this.$route.params?.action === 'crawler-executions') {
			await this.getCrawlerExecutions();
		}
	},
};
</script>

<style scoped>

.btn-refresh {
  display: flex;
  flex: 0 0 45px;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 2px solid var(--header-text-color-hover);
  color: var(--primary-bg-header);
  cursor: pointer;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  transition: all .2s ease-in-out 0s;
}

.btn-refresh:hover {
  background: var(--header-text-color-hover);
}

.crm-button:disabled {
  opacity: .5;
  cursor: not-allowed;
}

.crm-button:disabled:hover {
  background-color: #104375;
}

.partner-integrations-search-bar {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  border-bottom: 1px solid #dee2e6;
  background-color: white;
}

.partner-integrations-search-form {
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  min-width: 0;
}

.partner-integrations-search-form input[type="text"] {
  height: 58px;
  flex: 1 1 auto;
  border: 0;
  padding: 0 20px;
  outline: none;
  --webkit-outline: none;
  --moz-outline: none;
}

.height-calc {
  height: calc(100vh - 210px) !important;
}

.height-calc-h {
  height: calc(100vh - 240px) !important;
}

.height-calc-h-i {
  height: calc(100vh - 319px) !important;
}

.process-list,
.integrations-list,
.quotations-list {
  margin: 0;
  padding: 0;
  list-style: none;
  overflow: auto;
  height: 100%;
}

.process-list li {
  opacity: 0.75;
  transition: all 0.2s ease-in-out 0s;
}

.process-list li:not(.no-hover):hover,
.process-list li.active {
  opacity: 1;
  background-color: #e7e8ec;
}

.process-list li.visualized {
  opacity: 1;
  background-color: #e1e1e1;
}

.process-list li a {
  color: inherit;
  display: block;
  padding: 10px 20px;
}

.process-list li:not(:last-of-type) a {
  border-bottom: 1px solid #e2e2e2;
}

.integrations-list,
.integrations-list li {
  position: relative;
}

.integrations-list li.inconsistency {
  background-color: #e74c3c40;
}

.integrations-list li:not(.no-border)::before {
  content: "";
  display: block;
  width: 1px;
  position: absolute;
  top: -5px;
  bottom: -5px;
  left: calc(50% - 1px);
  /* margin: 0 auto; */
  border: 1px dashed #dee2e6;
  /* z-index: 2; */
}

.integrations-list-header {
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
}

.integrations-list .received,
.integrations-list .actual {
  flex: 0 1 40%;
  position: relative;
}

.integrations-list .actions {
  flex: 0 0 22%;
  margin-left: -1%;
  margin-right: -1%;
  position: relative;
  /* z-index: 3; */
}

.integrations-list .item-head {
  max-width: 80%;
  border-radius: 5px;
  background-color: #104375;
  color: #fff;
  font-weight: bold;
  padding: 3px 15px;
  text-align: center;
  font-size: 1rem;
  position: absolute;
  top: -15px;
  left: 0;
  right: 0;
  margin: 0 auto;
}

.integrations-list .item-head.dark {
  background-color: #343a40;
}

.number-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 99999px;
  width: 35px;
  height: 35px;
  background-color: #868ba1;
  color: #fff;
  font-weight: bold;
}

.justification {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1rem;
}

.justification-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid var(--primary);
  position: absolute;
  bottom: 1rem;
  right: 1rem;
}

.justification-btn-searates,
.justification-btn-sowhub-crawler {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid #104375;
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  top: 2.5rem;
}

.justification-btn-sowhub-crawler-group {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  top: 2.5rem;
}

.justification-btn-sowhub-crawler-group .justification-btn-sowhub-crawler {
  position: relative;
  bottom: unset;
  right: unset;
  top: unset;
}

@media screen and (max-width: 1330px) {
  .justification-btn {
    position: relative;
    bottom: unset;
    right: unset;
    /* margin: 1rem auto 0 auto; */
  }

  .justification-btn-searates,
  .justification-btn-sowhub-crawler,
  .justification-btn-sowhub-crawler-group {
    position: relative;
    bottom: unset;
    right: unset;
	top: unset;
    /* margin: 1rem auto 0 auto; */
  }

  .justification {
	margin-top: 0.7rem;
	flex-direction: row-reverse;
  }
}

.text-color-primary {
  color: var(--header-text-color-hover);
}

.quotation-type.navio,
.quotation-type.containerr {
  background-color: #80b7e230;
}

.quotation-type.aviao {
  background-color: #dee2e630;
}

.quotation-type.caminhao {
  background-color: #868ba130;
}

.config-title {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.useHint {
    position: relative;
}

.useHint .hint {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    background-color: rgb(203, 94, 82);
    padding: 0.50rem 1rem;
    z-index: 999999;
    color: #FFFFFF;
    border-radius: 5px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
	min-width: 150px;
}

.useHint:hover .hint {
    top: 150%;
    opacity: 1;
    visibility: visible;
}

.useHint .hint::before {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent rgb(203, 94, 82) transparent;
    pointer-events: none;
}

.crawler-error-modal {
	display: flex;
	flex-direction: column;
	gap: 1.25rem;
}

.crawler-error-section {
	border: 1px solid #e9ecef;
	border-radius: 8px;
	padding: 1rem 1.25rem;
	background-color: #fff;
}

.crawler-error-section-title {
	font-size: 0.875rem;
	font-weight: 600;
	color: #495057;
	margin-bottom: 0.75rem;
	text-transform: uppercase;
	letter-spacing: 0.03em;
}

.crawler-error-grid {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 0.625rem 2rem;
}

.crawler-error-field {
	display: grid;
	grid-template-columns: 160px 1fr;
	align-items: center;
	gap: 0.75rem;
	min-height: 28px;
}

.crawler-error-label {
	font-size: 0.8125rem;
	color: #6c757d;
	font-weight: 500;
}

.crawler-error-value {
	font-size: 0.875rem;
	color: #212529;
	word-break: break-word;
}

.crawler-error-value--mono {
	font-family: monospace;
	font-size: 0.8125rem;
}

.crawler-error-value--with-info {
	display: inline-flex;
	align-items: center;
	gap: 8px;
}

.crawler-rule-info-trigger {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	border: 1.5px solid #104375;
	border-radius: 50%;
	color: #104375;
	background-color: #fff;
	cursor: help;
	flex-shrink: 0;
}

.crawler-rule-info-trigger .fa {
	font-size: 11px;
	line-height: 1;
}

.crawler-rule-info-trigger--grid .fa {
	margin-left: 1px;
}

.crawler-error-status-badge {
	padding: 4px 10px;
	text-transform: uppercase;
	font-size: 0.75rem;
}

.crawler-error-alert {
	background-color: #f8f9fa;
	border: 1px solid #dee2e6;
	border-left: 4px solid #6c757d;
	border-radius: 6px;
	padding: 0.75rem 1rem;
	font-size: 0.875rem;
	color: #343a40;
	line-height: 1.5;
	white-space: pre-wrap;
	word-break: break-word;
}

.crawler-error-alert--danger {
	background-color: #fff5f5;
	border-color: #f5c6cb;
	border-left-color: #dc3545;
	color: #721c24;
}

.crawler-error-payload-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
	margin-bottom: 0.75rem;
}

.crawler-error-payload {
	background-color: #f8f9fa;
	border: 1px solid #dee2e6;
	border-radius: 6px;
	padding: 12px;
	max-height: 380px;
	overflow: auto;
	font-size: 12px;
	white-space: pre-wrap;
	word-break: break-word;
	margin-bottom: 0;
}

.crawler-error-modal .config-table-tag {
	display: inline-block;
	padding: 0.1rem 0.5rem;
	border-radius: 5px;
	font-weight: 400;
	color: white;
	font-size: 0.8rem;
}

.crawler-error-modal .config-table-tag.success {
	background-color: #00a068;
}

.crawler-error-modal .config-table-tag.danger {
	background-color: #dc3545;
}
</style>

<style scoped>
.registrations-container {
	display: flex;
	background-color: white;
	overflow: hidden;
}

.registrations-main {
  padding: 1.5rem;
  grid-column: span 9;
  overflow: hidden;
  height: 100%;
  width: 100%;
}
</style>

<style>

.label-form {
	color: #868ba1;
	font-weight: 400;
}

.alert-error-danger {	
	display: none;
	font-size: 0.875rem;
	font-weight: 400;
	margin-top: 2px;
}

.swal2-select.modify option.placeholder {
    color: #868ba1;
    font-style: italic;
}

.swal2-select.modify.input-danger {
	border: 1px solid var(--red) !important;
}

.swal2-textarea.modify,
.swal2-select.modify {
	width: 100% !important;
    height: 45px !important;
    outline: none !important;
    --webkit-ountline: none !important;
    --moz-outline: none !important;
	border: 1px solid #d9d9d9 !important;
    border-radius: 8px !important;
	margin: 0 !important;
	font-size: inherit !important;
}

.vue-tooltip.tooltip-custom {
	z-index: 100001 !important;
	background: #104375 !important;
    color: #FFFFFF !important;
    padding: 5px 10px;
	max-width: 320px;
	white-space: normal;
}

.vue-tooltip.tooltip-custom-danger {
	background: #CD6155 !important;
    color: #FFFFFF !important;
    padding: 5px 10px;
}

.vue-tooltip.tooltip-custom-danger .tooltip-arrow{
	border-color: #CD6155 !important;
}

.vue-tooltip.tooltip-custom-success {
	background: #00A068 !important;
    color: #FFFFFF !important;
    padding: 5px 10px;
}

.vue-tooltip.tooltip-custom-success .tooltip-arrow{
	border-color: #00A068 !important;
}
</style>
